export enum RingComplianceStatus {
  WaitingCompliance = 'WAITING_COMPLIANCE',
  Compliant = 'COMPLIANT',
  Approved = 'APPROVED',
  Refused = 'REFUSED',
}

export const AllRingComplianceStatus = [
  RingComplianceStatus.WaitingCompliance,
  RingComplianceStatus.Compliant,
  RingComplianceStatus.Approved,
  RingComplianceStatus.Refused,
];

export const RingComplianceWithoutValidationStatus = [
  RingComplianceStatus.WaitingCompliance,
  RingComplianceStatus.Compliant,
];
